import moment from 'moment'

const dateMixins = {
   computed: {
    formattedDate: function() {
      // return this.modelValue ? moment(this.modelValue) : null
      return this.modelValue ? this.modelValue : null
    },
    maxDateComputed360: function() {      
      var date = moment().add(360,'days')
      return this.formatDate(date)
    },
    maxDateComputed365: function() {
      var date = moment().add(365,'days')      
      return this.formatDate(date)
    },
    minDateComputed: function() {
      return this.formatDate(moment())
    }
  },
  methods: {
    formatDate: function(date) {
      var d = moment(date)
      // var d = Date(date)
      var month = '' + (d.month() + 1)
      var day = '' + d.date()
      var year = d.year()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('-')
    },
    convertDateToString: function(date) {
      var d = date
      // var d = Date(date)
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('-')
    }
  }
 
}

export default dateMixins
